






































































































































































































































































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwIcon } from '@libs/unified-ui-framework/src/shared/sw-icon';
import { SwPanelGroup } from '@libs/unified-ui-framework/src/shared/sw-panel';
import  SwPanel from './sw-panel/sw-panel-simulator.vue';
import { SwForm, SwFormRow } from '@libs-uuif/shared/sw-form';
import { SwSelect, SelectOption } from '@libs-uuif/shared/sw-select';
import { SwToggle } from '@libs-uuif/shared/sw-toggle';
import { State } from 'vuex-class';
import store, { RootStoreState } from '@/store';
import Ns from './../../../assets/ns.svg';
import CASB from './../../../assets/Icon_CASB_Color.svg';
import IconEndpoint from './../../../assets/Icon_Endpoint_SSC_Color.svg';
import Waf from './../../../assets/Logo_WAF_OrangeColor.svg';
import Atp from './../../../assets/Icon_Capture_ATPw_RTDMI_OrangeColor.svg';
import { Threat } from '../../../modules/sw-ftr-bill-meter/data';
import CloudEmail from './../../../assets/Icon_Cloud_Email_Security_OrangeColor.svg';
import NGAV from './../../../assets/Icon_NG-AV_OrangeColor.svg';
import NGAVATP from './../../../assets/Icon_NG-AV+ATP_OrangeColor.svg';
/**
 * @event click `(event: MouseEvent)`
 */
@Component({
  components: {
    SwIcon,
    SwPanelGroup,
    SwToggle,
    SwPanel,
    SwFormRow,
    SwSelect,
    SwForm,
  },
})
export default class SwWhatIfSimulator extends SwExtendedVue {

  @Prop({ default: '#ff791a' })
  tabColor: string;
  @State((state: RootStoreState) => (state.CoreStoreModule.defconWhatIf))
  defconWhatIf: number;
  @State((state: RootStoreState) => (state.CoreStoreModule.defconPreciseWhatIf))
  defconPreciseWhatIf: number;

  @State((state: RootStoreState) => (state.CoreStoreModule.tenants))
  tenants: any;

  @State((state: RootStoreState) => (state.CoreStoreModule.layerOneInnerLayersActivatedWhatIf))
  layerOneInnerLayersActivatedWhatIf: any;

  @State((state: RootStoreState) => (state.CoreStoreModule.layerTwoInnerLayersActivatedWhatIf))
  layerTwoInnerLayersActivatedWhatIf: any;

  @State((state: RootStoreState) => (state.CoreStoreModule.layerThreeInnerLayersActivatedWhatIf))
  layerThreeInnerLayersActivatedWhatIf: any;

  @State((state: RootStoreState) => (state.CoreStoreModule.selectedTenantId))
  selectedTenantId: string;

  @State((state: RootStoreState) => (state.CoreStoreModule.weights))
  weights:any;

  @State((state: RootStoreState) => (state.CoreStoreModule.billmeterloading))
  loading:boolean;

  @State((state: RootStoreState) => (state.CoreStoreModule.consolidatedThreats))
  consolidatedThreats: any | undefined;

  @State((state: RootStoreState) => (state.CoreStoreModule.tenantid))
  tenantid: string | undefined;

  @State((state: RootStoreState) => (state.CoreStoreModule.threatsWhatIf))
  threatsWhatIf: any | undefined;

  @State((state: RootStoreState) => (state.CoreStoreModule.whatIfThreatPercent))
  whatIfThreatPercent: number;

  @Prop({ default: false })
  noBorder: boolean;
  companiesList: any = [
    { name: 'Proofpoint', id: 'Proofpoint' },
    { name: 'Mimecast', id: 'Mimecast' },
    { name: 'Barracuda', id: 'Barracuda' },
    { name: 'FortiMail', id: 'FortiMail' },
    { name: 'Trend Micro', id: 'Trend Micro' },
    { name: 'Sophos', id: 'Sophos' },
    { name: 'Symantec', id: 'Symantec' },
    { name: 'Microsoft', id: 'Microsoft' },
  ];
  cssPrefix: string = 'sw-what-if';
  showBreakdownOptions: boolean = true;
  showBreakdownDetail: boolean = false;
  showThirdPartyDetails: boolean = false;
  selected: string = '';
  expandedPanels: string[] = [];
  innerContext: 'SonicOSx' | 'GMS' = 'SonicOSx';
  internalSelectedTenantId: string = '';
  defconCounted:number = 0;
  // defcon:number = 0;
  defconTotal:number = 0;
  layer1Expanded:boolean = false;
  layer2Expanded:boolean = false;
  layer3Expanded:boolean = false;
  // defconPrecise:number = 0;
  defconColors:string[] = ['#660001', '#FD9721', '#FDCB2E', '#EDE385', '#97CC2D'];
  threatsLocal: Threat[] = [];
  layersActive:boolean[] = [false, true, true, true];
  layersActiveCopy: boolean[] = this.layersActive;
  layerToggledRecently = 0;
  resetAllowed = false;
  layerThreeInnerLayersActivatedLocal = [true, true, true];
  layerTwoInnerLayersActivatedLocal = [true, true];
  layerOneInnerLayersActivatedLocal = [true, true];
  defconPrecise1: number = this.defconPreciseWhatIf;
  defcon1: number = this.defconWhatIf;
  emailBreakDown: number[] = [9, 9];
  nsBreakDown: number[] = [13, 13, 26];
  endpointBreakDown: number[] = [13, 17];
  breakDown: number[] = [30, 18, 52];
  calculateSubLayer10: number = 0;
  calculateSubLayer11: number = 0;
  calculateSubLayer20: number = 0;
  calculateSubLayer21: number = 0;
  calculateSubLayer30: number = 0;
  calculateSubLayer31: number = 0;
  calculateSubLayer32: number = 0;
  calculateLayer1: number = 0;
  calculateLayer2: number = 0;
  calculateLayer3: number = 0;
  ngImg = NGAV;
  ngAtp = NGAVATP;
  img: string;
  nsImg: any = Ns;
  casbImg: any = CASB;
  iconEndpointImg = IconEndpoint;
  wafImg = Waf;
  atpImg = Atp;
  cloudEmailImg = CloudEmail;

  // @Watch('selectedTenantId')
  // onSelectedTenantIdChange() {
  //   this.resetAllowed = false;

  //   this.$nextTick(() => {
  //     for (let i = 0; i < this.threats.length; i += 1) {
  //       this.threats[i].isPenetrating = false;
  //       const consolidatedThreat = this.consolidatedThreats[this.threats[i].id];

  //       if (this.selectedTenantId in consolidatedThreat['tenants']) {
  //         this.threats[i].isPenetrating = false;
  //       } else {
  //         this.threats[i].isPenetrating = true;
  //       }
  //     }

  //   //   this.layerThreeInnerLayersActivated = [true, true, true];
  //   //   this.layerTwoInnerLayersActivated = [true, true];
  //   //   this.layerOneInnerLayersActivated = [true, true];
  //   //   this.updateWalls();
  //   //   this.checkIfToggleLayerIsNeeded();
  //     this.$nextTick(() => {
  //       this.start();
  //     });
  //   });
  // }

  @Watch('resetAllowed')
  commitResetAllowedToStore() {
    store.commit('setBmResetAllowed', { bmResetAllowed: this.resetAllowed });
    // this.updateDefcon();
  }

  // start() {
  //   this.updateLayerPenetrating();
  //   this.commitDefconToStore();
  // }
  allowReset(i: number) {
    this.resetAllowed = true;
    // store.commit('setBmResetAllowed', { bmResetAllowed: this.resetAllowed });
    this.layerToggledRecently = i;
    this.updateLayerPenetrating();
    // this.layersActive[i] = !this.layersActive[i];
    // this.toggleLayer();
    this.updateDefcon();
  }

  calculateLayer(layer: number) {
    let defconCounted = 0;
    const defconTotal = 55;
    this.threatsLocal.forEach((threat:Threat) => {
      // defconTotal += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
      if (layer === 1) {
        if (threat.innerLayer !== undefined && this.layerOneInnerLayersActivatedWhatIf[threat.innerLayer] && layer === threat.layer && threat.show) {
          defconCounted += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
        }
      }
      if (layer === 2) {
        if (threat.innerLayer !== undefined && this.layerTwoInnerLayersActivatedWhatIf[threat.innerLayer] && layer === threat.layer && threat.show) {
          defconCounted += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
        }
      }
      if (layer === 3) {
        if (threat.innerLayer !== undefined && this.layerThreeInnerLayersActivatedWhatIf[threat.innerLayer] && layer === threat.layer && threat.show) {
          defconCounted += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
        }
      }
    });
    const val = Math.ceil(defconCounted / defconTotal * 100);
    console.log(`${layer} ,+ ${val}`);
    return val;
  }

  afterDestroy() {
    if (this.whatIfThreatPercent > 0) {
      store.commit('setWhatIfThreatPercent', { whatIfThreatPercent: 0 });
    }
  }

  @Watch('threatsLocal')
  calculateAllLAyers() {
    this.calculateSubLayer10 = this.calculateSubLayer(1, 0) === 10 ? 11 : this.calculateSubLayer(1, 0);
    this.calculateSubLayer11 = this.calculateSubLayer(1, 1) === 21 ? 22 : this.calculateSubLayer(1, 1);
    this.calculateSubLayer20 = this.calculateSubLayer(2, 0);
    this.calculateSubLayer21 = this.calculateSubLayer(2, 1);
    this.calculateSubLayer30 = this.calculateSubLayer(3, 2) === 21 ? 22 : this.calculateSubLayer(3, 2);
    this.calculateSubLayer31 = this.calculateSubLayer(3, 1) === 16 ? 17 : this.calculateSubLayer(3, 1);
    this.calculateSubLayer32 = this.calculateSubLayer(3, 0);
    console.log(`${this.calculateSubLayer10 + this.calculateSubLayer11}%`);
    this.tempDatas[0].percentage = `${this.calculateSubLayer20 + this.calculateSubLayer21}%`;
    this.networkSecurityData[0].percentage = `${this.calculateSubLayer30 + this.calculateSubLayer31 + this.calculateSubLayer32}%`;
    this.enpointSecurityData[0].percentage = `${this.calculateSubLayer10 + this.calculateSubLayer11}%`;
    const val = this.calculateSubLayer10 + this.calculateSubLayer11 + this.calculateSubLayer20 + this.calculateSubLayer21
    + this.calculateSubLayer30 + this.calculateSubLayer31 + this.calculateSubLayer32;
    store.commit('setWhatIfThreatPercent', { whatIfThreatPercent: val });
  }

  calculateSubLayer(layer: number, subLayer: number) {
    let defconCounted = 0;
    const defconTotal = 55;
    this.threatsLocal.forEach((threat:Threat) => {
      if (layer === 1) {
        if (threat.innerLayer !== undefined && this.layerOneInnerLayersActivatedWhatIf[threat.innerLayer] && layer === threat.layer &&
         subLayer === threat.innerLayer  && threat.show) {
          defconCounted += (this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex]);
        }
      }
      if (layer === 2) {
        if (threat.innerLayer !== undefined && this.layerTwoInnerLayersActivatedWhatIf[threat.innerLayer] &&
         layer === threat.layer && subLayer === threat.innerLayer  && threat.show) {
          defconCounted += (this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex]);
        }
      }
      if (layer === 3) {
        if (threat.innerLayer !== undefined && this.layerThreeInnerLayersActivatedWhatIf[threat.innerLayer] &&
         layer === threat.layer && subLayer === threat.innerLayer  && threat.show) {
          defconCounted += (this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex]);
        }
      }
    });
    const val = Math.floor(defconCounted / defconTotal * 100);
    return val;
  }

  updateLayerPenetrating() {
    if (this.layerOneInnerLayersActivatedLocal[1]) {
      this.layerOneInnerLayersActivatedLocal[0] = true;
    }

    if (this.layerTwoInnerLayersActivatedLocal[1]) {
      this.layerTwoInnerLayersActivatedLocal[0] = true;
    }
    for (let i = 0; i < this.threatsLocal.length; i += 1) {
      if (this.threatsLocal[i].show || true) {
        const threat = this.threatsLocal[i];
        if (threat.layer === 3) {
          if (threat.innerLayer !== undefined && this.layerThreeInnerLayersActivatedLocal[threat.innerLayer]) {
            this.threatsLocal[i].isPenetrating = false;
          } else {
            this.threatsLocal[i].isPenetrating = true;
          }
        } else if (threat.layer === 2) {
          if (threat.innerLayer !== undefined && this.layerTwoInnerLayersActivatedLocal[threat.innerLayer]) {
            this.threatsLocal[i].isPenetrating = false;
          } else {
            this.threatsLocal[i].isPenetrating = true;
          }
        } else if (threat.layer === 1) {
          if (threat.innerLayer !== undefined && this.layerOneInnerLayersActivatedLocal[threat.innerLayer]) {
            this.threatsLocal[i].isPenetrating = false;
          } else {
            this.threatsLocal[i].isPenetrating = true;
          }
        }
      }
    }
  }

  @Watch('threatsLocal')
  commitThreats() {
    store.commit('setThreatsWhatIf', { threatsWhatIf: this.threatsLocal });
  }
  @Watch('layerOneInnerLayersActivatedLocal')
  commitLayerOne() {
    store.commit('setToggleLayerOneActivatedWhatIf', { layerOneInnerLayersActivatedWhatIf: this.layerOneInnerLayersActivatedLocal });
  }
  @Watch('layerTwoInnerLayersActivatedLocal')
  commitLayerTwo() {
    store.commit('setToggleLayerTwoActivatedWhatIf', { layerTwoInnerLayersActivatedWhatIf: this.layerTwoInnerLayersActivatedLocal });
  }
  @Watch('layerThreeInnerLayersActivatedLocal')
  commitLayerThree() {
    store.commit('setToggleLayerThreeActivatedWhatIf', { layerThreeInnerLayersActivatedWhatIf: this.layerThreeInnerLayersActivatedLocal });
  }

  tempDatas: any[] = [{
    id : 2,
    title : 'CAS AND EMAIL',
    img: 'CASB',
    percentage: '0%',
    options: {
      firstLabel: 'Email Security',
      secondLabel: 'Cloud Security',
    },
    summaryConfig: {
      text: '',
    },
  }];
  networkSecurityData: any[] = [{
    id : 3,
    title : 'NETWORK SECURITY',
    img: 'Ns',
    percentage: '0%',
    options: {
      firstLabel: 'Firewall',
      secondLabel: 'ATP',
      thirdLabel: 'WAF',
    },
    summaryConfig: {
      text: '',
    },
  }];
  enpointSecurityData: any[] = [{
    id : 1,
    title : 'ENDPOINT SECURITY',
    img: 'IconEndpoint',
    percentage: '0%',
    options: {
      firstLabel: 'Next-Gen AV',
      secondLabel: 'Next-Gen AV+ATP',
    },
    summaryConfig: {
      text: '',
    },
  }];
  onSuccess = false;
  toggleenable:boolean = false;
  // layerOneInnerLayersToggleActivated: boolean[] = [false, true];
  contextOptions: SelectOption[] = [
    { id: 'SonicOSx', label: 'Context: SonicOS', value: 'SonicOSx' },
    { id: 'GMS', label: 'Context: GMS', value: 'GMS' },
  ];
  handlePanelChange(expandedPanels: string[]) {
    this.expandedPanels = expandedPanels.slice(0);
  }
  onClickIcon() {
    this.showBreakdownDetail = true;
    this.showBreakdownOptions = false;
  }
  goBack() {
    this.showThirdPartyDetails = false;
    this.showBreakdownDetail = true;
    this.showBreakdownOptions = false;
  }
  // updateWalls() {
  //   this.threats.forEach((threat) => {
  //     if (threat.isPenetrating) {
  //       if (threat.layer === 3) {
  //         if (typeof threat.innerLayer !== 'undefined') {
  //           this.layerThreeInnerLayersActivated[threat.innerLayer] = false;
  //         }
  //       } else if (threat.layer === 2) {
  //         if (typeof threat.innerLayer !== 'undefined') {
  //           this.layerTwoInnerLayersActivated[threat.innerLayer] = false;
  //         }
  //       } else if (threat.layer === 1) {
  //         if (typeof threat.innerLayer !== 'undefined') {
  //           this.layerOneInnerLayersActivated[threat.innerLayer] = false;
  //         }
  //       }
  //     }
  //   });
  // }

  @Watch('layerThreeInnerLayersActivatedLocal', { immediate: true, deep: true })
  @Watch('layerTwoInnerLayersActivatedLocal', { immediate: true, deep: true })
  @Watch('layerOneInnerLayersActivatedLocal', { immediate: true, deep: true })
  updateDefcon() {
    // if (this.loading) {
    //   return;
    // }
    let defconCounted = 0;
    let defconTotal = 0;
    this.threatsLocal.forEach((threat:Threat) => {
      if (threat.show) {
        defconTotal += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
        if (!threat.isPenetrating) {
          defconCounted += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
        }
      }
    });
    this.defconPrecise1 = (4 * defconCounted / defconTotal) + 1;
    if (this.defconPrecise1 > 4 && this.defconPrecise1 < 5) {
      this.defcon1 = 4;
    } else if (this.defconPrecise1 < 2 && this.defconPrecise1 > 1) {
      this.defcon1 = 2;
    } else {
      this.defcon1 = Math.round(this.defconPrecise1);
    }
  }

  @Watch('defcon1')
  @Watch('defconPrecise1')
  commitDefconToStore() {
    store.commit('setDefconWhatIf', { defconWhatIf: this.defcon1 });
    store.commit('setDefconPreciseWhatIf', { defconPreciseWhatIf: this.defconPrecise1 });
  }
  updated() {
    // console.log(`${this.layerOneInnerLayersActivated}`);
    console.log(this.layerOneInnerLayersActivatedWhatIf, this.layerTwoInnerLayersActivatedWhatIf, this.layerThreeInnerLayersActivatedWhatIf);
    this.threatsLocal = this.threatsWhatIf;
    this.processThreatData();
    this.updateDefcon();
    this.commitDefconToStore();
    this.layerOneInnerLayersActivatedLocal = this.layerOneInnerLayersActivatedWhatIf;
    this.layerTwoInnerLayersActivatedLocal = this.layerTwoInnerLayersActivatedWhatIf;
    this.layerThreeInnerLayersActivatedLocal = this.layerThreeInnerLayersActivatedWhatIf;
    store.commit('setWhatIfThreatPercent', { whatIfThreatPercent: 0 });
    this.calculateAllLAyers();
  }
  created() {
    // console.log(`${this.layerOneInnerLayersActivatedWhatIf}`);
    console.log(this.layerOneInnerLayersActivatedWhatIf, this.layerTwoInnerLayersActivatedWhatIf, this.layerThreeInnerLayersActivatedWhatIf);
    this.threatsLocal = this.threatsWhatIf;
    this.processThreatData();
    this.updateDefcon();
    this.commitDefconToStore();
    this.layerOneInnerLayersActivatedLocal = this.layerOneInnerLayersActivatedWhatIf;
    this.layerTwoInnerLayersActivatedLocal = this.layerTwoInnerLayersActivatedWhatIf;
    this.layerThreeInnerLayersActivatedLocal = this.layerThreeInnerLayersActivatedWhatIf;
    store.commit('setWhatIfThreatPercent', { whatIfThreatPercent: 0 });
    this.calculateAllLAyers();
  }

  processThreatData() {
    for (let i = 0; i < this.threatsLocal.length; i = i + 1) {
      this.threatsLocal[i].globalIndex = i;
    }
    // this.threatsLocal = this.threatsLocal.filter(threat => threat.show);
  }
  // mounted() {
  //   this.calculateAllLAyers();
  // }
}
